import { MobileBottomSheet } from "@/components/mobileBottomSheet/mobileBottomSheet";
// eslint-disable-next-line max-len
import { useAttendanceMobileAddVoceBottomSheet } from "./attendanceMobileAddVoceBottomSheet/useAttendanceMobileAddVoceBottomSheet";
import { showTranslated, translate, TranslatorKeys } from "@/config/translator";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import clsx from "clsx";
import PspButton from "@/components/pspButton/PspButton";

type AttendanceMobileAddVoceBottomSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  employeeMatricola: number;
  employeeFiliale: number;
};

export function AttendanceMobileAddVoceBottomSheet({
  isOpen,
  onClose,
  employeeMatricola,
  employeeFiliale,
}: AttendanceMobileAddVoceBottomSheetProps) {
  const {
    vociSearchResults,
    selectedVoce,
    setSelectedVoce,
    lang,
    voceSearchQuery,
    setVoceSearchQuery,
    quantity,
    setQuantity,
    base,
    setBase,
    onCloseWrapper,
    attendance,
    selectedMonth,
    selectedYear,
    onAddVoce,
  } = useAttendanceMobileAddVoceBottomSheet({
    employeeMatricola,
    onClose,
    employeeFiliale,
  });

  return (
    <MobileBottomSheet
      isOpen={isOpen}
      onClose={onCloseWrapper}
      title={
        selectedVoce ? (
          <div className="flex flex-col">
            <div className="font-medium">
              {showTranslated(selectedVoce.name, lang)}
            </div>
            <div className="text-font-secondary text-base font-normal">
              {attendance?.employee.name ?? ""} |{" "}
              {translate(
                `month${
                  selectedMonth !== undefined
                    ? selectedMonth - 1
                    : selectedMonth
                }` as TranslatorKeys,
                lang,
              )}{" "}
              {selectedYear}
            </div>
          </div>
        ) : (
          translate("selectVoce", lang)
        )
      }
    >
      {!selectedVoce ? (
        <div className="flex flex-col gap-6">
          <PspTextInput
            labelString={translate("searchVoce", lang)}
            value={voceSearchQuery}
            onChange={setVoceSearchQuery}
          />
          <div className="flex flex-col gap-3">
            {vociSearchResults?.map((voce) => (
              <button
                className={clsx(
                  "flex",
                  "justify-start",
                  "flex-row",
                  "items-center",
                  "shadow-sm",
                  "bg-white",
                  "rounded-lg",
                  "p-3",
                )}
                onClick={() => setSelectedVoce(voce)}
              >
                {showTranslated(voce.name, lang)}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex flex-col h-full">
          <div className="flex flex-col gap-4">
            <div className="relative">
              <PspTextInput
                labelString={translate(
                  selectedVoce.voceType === "amount" ? "amount" : "base",
                  lang,
                )}
                hideNumberInputArrows
                type="number"
                value={base}
                onChange={setBase}
                placeholderString="0"
              />
              <div className="absolute bottom-1.5 text-lg font-medium text-font-secondary right-4">
                €
              </div>
            </div>
            {selectedVoce.voceType === "base_by_quantity" && (
              <PspTextInput
                labelString={translate("quantity", lang)}
                value={quantity}
                onChange={setQuantity}
                placeholderString="0"
                hideNumberInputArrows
                type="number"
              />
            )}
          </div>

          <div className="flex-1" />

          <PspButton onClick={onAddVoce} appearance="primary">
            {translate("save", lang)}
          </PspButton>
        </div>
      )}
    </MobileBottomSheet>
  );
}
